import { render, staticRenderFns } from "./PrintOrders.vue?vue&type=template&id=576e4d0b"
import script from "./PrintOrders.vue?vue&type=script&lang=js"
export * from "./PrintOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports